<template>
  <el-form-item :label="i18nt('designer.setting.defaultValue')">
    <el-date-picker :type="datePickerType" v-model="optionModel.defaultValue" @change="emitDefaultValueChange" :format="pickerFormat" :value-format="optionModel.format" style="width: 100%">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import { toRefs, computed } from 'vue';

import { useI18n } from '@/utils/i18n';
import { useProperty } from '../propertyMixin';
import { useDateDefaultValue } from '../field-date/date-defaultValue';

export default {
  name: 'm-datetime-defaultValue-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    const pickerFormat = computed(() => {
      return props.optionModel.format
        .replace(/\/|年|月/g, '-')
        .replace(/时|分/g, ':')
        .replace(/日|秒/g, '')
        .replace(/:$/, '');
    });

    return {
      i18nt,
      ...toRefs(props),
      ...useProperty(),
      ...useDateDefaultValue(),
      pickerFormat,
    };
  },
};
</script>

<style scoped></style>
